import React from 'react';

import { List, notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import { Link } from 'react-router-dom';
import Loading from '../../../common/Loading';

import getTipoAtenciones from '../../../../graphql/querys/otros/getTipoAtenciones.graphql';
import deleteTipoAtencion from '../../../../graphql/mutations/otros/deleteTipoAtencion.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getTipoAtenciones, { options: { fetchPolicy: 'network-only' } }),
  graphql(deleteTipoAtencion, {
    name: 'deleteTipoAtencion',
    options: {
      refetchQueries: [{ query: getTipoAtenciones }],
    },
  })
)
class VerTipoAtenciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este tipo de atencion?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteTipoAtencion({
            variables: { _id: id },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Tipo de atencion eliminada',
              description: 'Se ha eliminado correctamente el tipo de atencion',
            });
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el tipo de atencion'
            );
            console.log(err);
            errorService(err, {
              _id: id,
            });

            Modal.error({
              title: 'Error en la eliminacion del tipo de atencion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { loading } = this.state;

    let listaTipoAtenciones = this.props.data.getTipoAtenciones;

    if (!listaTipoAtenciones) {
      listaTipoAtenciones = [];
    }

    return (
      <div>
        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          dataSource={listaTipoAtenciones}
          renderItem={item => (
            <List.Item style={{ margin: 15 }}>
              <List.Item.Meta
                title={
                  <Link to={`/admin/otros/tipo_atencion`}>
                    <h2>Tipo Atencion con titulo de: {item.nombre}</h2>
                  </Link>
                }
              />
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default withApollo(VerTipoAtenciones);
